<template>
    <div class="themeItem">
        <h2 class="theme0">{{parks_info.name}}</h2>
        <div class="gallery">
            <thumbnail v-for="(i,n) in this.parks_info.content" :parks_item="i" :key="n"></thumbnail>
        </div>
    </div>
</template>

<script>
    import thumbnail from './thumbnail';

    export default {
        props: ["parks_info"],
        name: "themeItem",
        components: {
            thumbnail
        },

    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';

    .themeItem {
        width: @width;
        padding: 15px;
        .border-bottom(5px; @bg);
        .box-sizing;
        h2 {
            height: 30px;
        }
        .gallery {
            display: flex;
            flex-wrap: wrap;
            & > div {
                margin-right: 3.6%;
                &:nth-child(2n) {
                    margin-right: 0;
                }
            }

        }

    }

    .theme0 {
        color: #feb302;
    }

    .theme1 {
        color: #018315;
    }

    .theme2 {
        color: #873539;
    }

    .theme3 {
        color: #8fc320;
    }

    .theme4 {
        color: #d4c303;
    }

    .theme5 {
        color: #3875a1;
    }

    .them6 {
        color: #00b8ee;
    }

    @media (min-width: 768px)  and (orientation: portrait){
        .themeItem {
            width: @width;
            padding: 15px;
            .border-bottom(5px; @bg);
            .box-sizing;
            h2 {
                height: 40px;
                font-size: 1.4rem;
            }
            .gallery {
                & > div {
                    margin-right: 3.6%;
                    &:nth-child(2n) {
                        margin-right: 3.6%;
                    }
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                }

            }

        }
    }

</style>
